<template>
  <div class="search" :style="{'top': top}">
    <input type="text" id="search-address" class="ant-input" :style="{'width': width}" :placeholder="$t('global.qsrdz')">
  </div>
</template>
<script>
export default {
  props: {
    map: {
      required: true
    },
    width: {
      default: '25%'
    },
    top: {
      default: '20px'
    }
  },
  data () {
    return {}
  },
  methods: {
    init () {
      // 创建一个自动完成对象
      let ac = new BMap.Autocomplete(
        {
          input : 'search-address',
          location : this.map
        }
      )
      let myValue
      ac.addEventListener("onconfirm", (e) => {   //鼠标点击下拉列表后的事件
        // console.log(e)
        let _value = e.item.value
        myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business
        this.setPlace(myValue)
      })
    },
    setPlace (myValue) {  
      let myFun = () => {
        let pp = local.getResults().getPoi(0).point    //获取第一个智能搜索的结果
        // console.log(pp)
        let zoom = this.map.getZoom()
        // console.log(zoom)
        if (zoom < 16) {
          this.map.setZoom(16)
        }
        this.map.setCenter(pp)
      }
      let local = new BMap.LocalSearch(this.map, { //智能搜索
        onSearchComplete: myFun
      })
      local.search(myValue)
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="less" scoped>
.search {
  position: relative;
  // right: 30px;
  top: 20px;
  left: 50px;
  text-align: center;
  height: 0;
  .ant-input {
    width: 20%;
    opacity: .95;
    z-index: 100;
  }
}
</style>